import {
    Home,
    Files,
    Users,
    MessagesSquare,
    Folder,
    Settings,
    ChevronLeft,
    ChevronRight,
} from "lucide-react";
import { useNavigationStore } from "../stores/navigationStore";
import { useBrandStore } from "../stores/brandStore";

const NavigationPane = () => {
    const { isNavExpanded, setIsNavExpanded } = useNavigationStore();
    const { selectedBrand } = useBrandStore();
    const menuItems = [
        { icon: Home, label: "Home", path: "/homepage" },
        { icon: Files, label: "Brand Assets", path: "/assets" },
        { icon: Users, label: "Persona Library", path: "/persona-library" },
        {
            icon: MessagesSquare,
            label: "Persona Chat",
            path: "/chat-with-persona",
        },
        { icon: Folder, label: "My Projects", path: "/my-projects" },
        { icon: Settings, label: "Settings", path: "" },
    ];

    const logoMap: Record<number, string> = {
        1: "/ozempic_logo.png",
        2: "/xarelto_logo.png",
        3: "/tremfya_logo.png",
    };

    return (
        <div
            className={`${
                isNavExpanded ? "w-64" : "w-20"
            } bg-white border-r border-gray-200 flex flex-col relative transition-all duration-300`}
        >
            <div
                className={`p-6 flex flex-col items-center text-center ${
                    isNavExpanded ? "" : "p-4"
                }`}
            >
                <img
                    src="/synthio_logo.png"
                    alt="Synthio Logo"
                    className="h-8 w-auto mb-2"
                />
                {isNavExpanded && (
                    <div className="flex flex-col items-center">
                        <span className="font-bold text-gray-800">
                            MLR Review Automation
                        </span>
                        <div className="text-sm text-gray-500">
                            Powered by AI personas
                        </div>
                    </div>
                )}
            </div>

            <div className="flex justify-center items-center py-1">
                <img
                    src={logoMap[selectedBrand]}
                    alt="Ozempic Logo"
                    className="h-10 w-auto"
                />
            </div>

            <nav className="flex-1">
                {menuItems.map((item) => (
                    <a
                        key={item.label}
                        href={item.path}
                        className={`flex items-center ${
                            isNavExpanded
                                ? "px-6 py-3"
                                : "px-0 py-3 justify-center"
                        } text-gray-600 hover:bg-gray-50 hover:text-[#5a55f4]`}
                    >
                        <item.icon
                            size={20}
                            className={isNavExpanded ? "mr-3" : ""}
                        />
                        {isNavExpanded && item.label}
                    </a>
                ))}
            </nav>

            <div className="border-t border-gray-200">
                <div
                    className={`p-4 flex items-center ${
                        isNavExpanded
                            ? "justify-center space-x-3"
                            : "justify-center"
                    }`}
                >
                    <img
                        src="https://pub-a8e570ecca3742e1828152dfc03cecad.r2.dev/images/genmab/persona_1.jpeg"
                        alt="Profile"
                        className="w-8 h-8 rounded-full"
                    />
                    {isNavExpanded && (
                        <div className="flex items-center justify-center text-gray-600 hover:text-[#5a55f4] cursor-pointer">
                            Michelle Kim
                        </div>
                    )}
                </div>

                <div className="flex justify-center pb-4">
                    <button
                        onClick={() => setIsNavExpanded(!isNavExpanded)}
                        className="flex items-center justify-center"
                    >
                        {isNavExpanded ? (
                            <ChevronLeft size={20} />
                        ) : (
                            <ChevronRight size={20} />
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NavigationPane;
